/**
 * @module Components.PromoResolveError
 *
 * Shown on a checkout page when the promo/price resolve fails (a transport
 * error, not an invalid code — the endpoint always answers 200 otherwise).
 * Since the hardcoded price tables are gone, a failed resolve leaves no price to
 * render, so the page surfaces this instead of a perpetual loader, with a retry.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import ButtonVariant from "app/components/Button/ButtonVariant";
import styles from "./styles.module.scss";

type PropsDef = {
  onRetry: () => void;
};

const PromoResolveError = ({ onRetry }: PropsDef) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} role="alert">
      <p className={styles.message}>
        {t("We couldn't load pricing. Please check your connection and try again.")}
      </p>
      <ButtonVariant title={t("Retry")} buttonType="primary" onClickFunc={onRetry} />
    </div>
  );
};

export default PromoResolveError;
